import { AxiosResponse } from "axios";
import { useMutation, useQuery } from "react-query";
import { AppDispatch } from "../../store/store";
import { useDispatch } from "react-redux";
import { addContact, setContacts, updateContact } from "../../store/slices/contact.slice";
import { api } from "@data-phone/react-resource-server-auth";
import { Contact } from "@data-phone/react-generic/dist/components/Forms/Contacts";
import qs from "qs";

interface responseType {
  data: Contact[];
  status: string;
}


export interface contactQuery {
  updated_at: string;
}

const fetchContactsApi = async (query?: contactQuery) => {
  const response = await api.get(
    `${process.env.REACT_APP_CONTACT_API_URL}?${qs.stringify({
      ...(query?.updated_at ? { since: query.updated_at } : {}),
      fields: ["first_name", "last_name", "middle_name", "phones", "emails", "updated_at", "tags", "addresses"],
    })}`,
  );
  return response.data;
}

const addContactApi = async (data: any) => {
  const response: AxiosResponse<responseType> = await api.post(
    `${process.env.REACT_APP_CONTACT_API_URL}`,
    data
  );
  return response.data;
}

const updateContactApi = async (data: any) => {
  const response: AxiosResponse<responseType> = await api.put(
    `${process.env.REACT_APP_CONTACT_API_URL}/${data.id}`,
    data
  );
  return response.data;
}

export const useGetContacts = (query?: contactQuery) => {
  const dispatch: AppDispatch = useDispatch();
  return useQuery<any[], Error>(
    "contacts",
    () => fetchContactsApi(query),
    {
      enabled: false,
      onError: (error) => {
        console.log("failed", error);
      },
      onSuccess: (data) => {
        if (query?.updated_at) {
          dispatch(addContact(data))
        } else {
          dispatch(setContacts(data))
        }
      }
    }
  );
};

export const useAddContact = () => {

  return useMutation((data: any) => addContactApi(data), {
    onSuccess: () => {
      console.log("success");
    },
    onError: (error: any) => {
      console.log("error", error.response.data.error)
    },
  });
}

export const useUpdateContact = () => {
  const dispatch: AppDispatch = useDispatch();
  return useMutation((data: any) => updateContactApi(data), {
    onSuccess: (data) => {
      dispatch(updateContact(data));
    },
    onError: (error: any) => {
      console.log("error", error.response.data.error)
    },
  });
}